
import { Shield, CreditCard, Users, TrendingUp, Clock } from "lucide-react";
import type { Feature } from "@/types/home";
import { cn } from "@/lib/utils";

export const FeaturesGrid = () => {
  const features: Feature[] = [
    {
      icon: CreditCard,
      title: "Credit limits up to Ten million Ghana cedis",
      description: "Access substantial credit limits to finance your business needs and growth opportunities."
    },
    {
      icon: Shield,
      title: "Secure Asset backed Loans and purchases",
      description: "Use your assets as collateral for secure loans with better terms and competitive rates."
    },
    {
      icon: CreditCard,
      title: "Flexible Loan and purchases terms",
      description: "Choose from a variety of loan options with customizable repayment schedules that fit your needs."
    },
    {
      icon: Users,
      title: "Verified lenders and Merchants",
      description: "Connect with our network of trusted and verified lenders and merchants committed to quality service."
    },
    {
      icon: Clock,
      title: "Quick processing",
      description: "Experience fast loan processing with our efficient application and approval system."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-indigo-50 to-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 md:mb-14 animate-in slide-in-from-bottom duration-700 bg-gradient-to-r from-indigo-800 to-purple-700 bg-clip-text text-transparent">
          Why Choose Obotan
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={cn(
                "p-6 bg-white rounded-xl border border-indigo-100 shadow-sm hover:shadow-xl transition-all duration-500",
                "animate-in slide-in-from-bottom",
                "hover:scale-105 hover:border-indigo-200 transform",
                "flex flex-col h-full"
              )}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="mb-6 bg-gradient-to-br from-indigo-100 to-indigo-50 p-4 rounded-lg w-16 h-16 flex items-center justify-center">
                <feature.icon className="h-8 w-8 text-indigo-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">{feature.title}</h3>
              <p className="text-gray-600 flex-grow">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
